import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Row from "./Row";

const Table = ({ className, items = [], onStatusChange, onSelectionChange }) => {
  const [centers, setCenters] = useState(items);
  const [chooseAll, setСhooseAll] = useState(false);
  const [activeId, setActiveId] = useState(centers[0]?.id || null);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    setCenters(items);
    // When items change, re-evaluate chooseAll status
    if (items.length > 0 && selectedIds.length === items.length) {
      setСhooseAll(true);
    } else {
      setСhooseAll(false);
    }
  }, [items, selectedIds]); // Add selectedIds to dependency array

  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(selectedIds);
    }
  }, [selectedIds, onSelectionChange]);

  const handleStatusChange = (id, newStatus) => {
    const updatedCenters = centers.map(center => {
      if (center.id === id) {
        return { ...center, status: newStatus };
      }
      return center;
    });

    setCenters(updatedCenters);

    if (onStatusChange) {
      onStatusChange(id, newStatus);
    }
  };

  const handleSelect = (id) => {
    setSelectedIds(prev => {
      if (prev.includes(id)) {
        const newSelected = prev.filter(item => item !== id);
        setСhooseAll(newSelected.length === centers.length && centers.length > 0); // Correctly update chooseAll
        return newSelected;
      } else {
        const newSelected = [...prev, id];
        setСhooseAll(newSelected.length === centers.length && centers.length > 0); // Correctly update chooseAll
        return newSelected;
      }
    });
  };

  const handleSelectAll = () => {
    if (chooseAll) {
      setSelectedIds([]);
    } else {
      setSelectedIds(centers.map(center => center.id));
    }
    setСhooseAll(!chooseAll);
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              value={chooseAll}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Nom du Centre</div>
          <div className={styles.col}>Coordonnées</div>
          <div className={styles.col}>Adresse</div>
        </div>
        {centers.map((x, index) => (
          <Row
            item={x}
            key={x.id || index} // Use x.id as key if available, fallback to index
            activeId={activeId}
            activeTable={true}
            selected={selectedIds.includes(x.id)}
            onSelect={handleSelect}
            onStatusChange={handleStatusChange}
            setActiveId={setActiveId}
            setActiveTable={() => {}}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;